export const DashboardIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1723_5001)">
        <path
          d="M6.875 16.4583L10.2083 13.125C10.3255 13.008 10.4844 12.9422 10.65 12.9422C10.8156 12.9422 10.9745 13.008 11.0917 13.125L12.7083 14.7417C12.8255 14.8587 12.9844 14.9244 13.15 14.9244C13.3156 14.9244 13.4745 14.8587 13.5917 14.7417L16.925 11.4083"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.875 0.625H18.125C18.125 0.625 19.375 0.625 19.375 1.875V18.125C19.375 18.125 19.375 19.375 18.125 19.375H1.875C1.875 19.375 0.625 19.375 0.625 18.125V1.875C0.625 1.875 0.625 0.625 1.875 0.625Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.125 7.08301C3.125 7.57546 3.222 8.0631 3.41045 8.51807C3.59891 8.97304 3.87513 9.38644 4.22335 9.73466C4.57157 10.0829 4.98497 10.3591 5.43994 10.5476C5.89491 10.736 6.38254 10.833 6.875 10.833C7.36746 10.833 7.85509 10.736 8.31006 10.5476C8.76503 10.3591 9.17843 10.0829 9.52665 9.73466C9.87487 9.38644 10.1511 8.97304 10.3395 8.51807C10.528 8.0631 10.625 7.57546 10.625 7.08301C10.625 6.59055 10.528 6.10292 10.3395 5.64794C10.1511 5.19297 9.87487 4.77958 9.52665 4.43136C9.17843 4.08314 8.76503 3.80691 8.31006 3.61846C7.85509 3.43 7.36746 3.33301 6.875 3.33301C6.38254 3.33301 5.89491 3.43 5.43994 3.61846C4.98497 3.80691 4.57157 4.08314 4.22335 4.43136C3.87513 4.77958 3.59891 5.19297 3.41045 5.64794C3.222 6.10292 3.125 6.59055 3.125 7.08301Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.875 3.33301V7.08301L9.525 9.73301"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.75 4.58301H16.6667"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.75 7.5H16.6667"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1723_5001">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
